<script>
    import _                      from 'lodash'
    import { onMount }            from 'svelte';
    import * as api               from '../../shared/api.js'
    import Copy                   from '../../shared/Copy.svelte'
    import Modal                  from '../../shared/SemanticModal.svelte'
    import { 
        extractIdentifiers,
        loadInquiry
    } from './inquiry.js'

    export let item       
    export let onAction
    export let active = false
    
    let values   = {}
    let items    = []
    let working  = false
    let error    = false
    let loading  = false
    let provided = []

    $: loadKeys(active)
    $: ready    = isReady(values)
    $: label    = labelGiven(item)
    //$: provided = item && Object.keys(item.providedKeys) || []
    //$: provided = extractIdentifiers(item)

    function loadKeys(active) {
        if(active) {
            loading = true
            loadInquiry(item.protocol)
                .then(json => {
                    loading  = false
                    provided = extractIdentifiers(json)
                    items    = json.keys.map( (it, idx) => { return { ...it, idx } })
                })
        } else {
            items = []
        }
    }

    function isReady(values) {
        return items
            .map(   it  => it.idx)
            .map(   idx => values[idx])
            .map(   it  => _.isEmpty(it))
            .every( it  => it === false)
    }

    function labelGiven(item) {
        return item ? item.real || '' : ''
    }

    function icon(value) {
        return _.isEmpty(value) ? 'orange question circle outline' : 'green check circle outline'
    }

    function cancel() {
        values = {}
        onAction(false)
    }

    function identify() {
        
        const data = items.map(it => {
            return {
                place: it.place.id,
                field: it.field.id,
                value: values[it.idx]
            }
        })
        
        working = true

        return api.post('/inquiry/identify', { id: item.protocol, data })
            .then(api.toJsonIf200)
            .then(inquiry => {
                working = false
                error   = false
                values  = {}                
                onAction(inquiry)
            })
            .catch(err => {
                working = false
                error   = err
            })        
    }

    function copyText(text) {
        return () => {
            navigator.clipboard.writeText(text).catch(console.error)
        }
    }
</script>
<Modal {active}>
    <div class="ui tiny modal visible active">
        <div class="header">
            Identificação do Titular
        </div>
        <div class="content">
            <h4>
                Forneça todos os dados titular <b>{ label }</b>
            </h4>        
            <div class="ui left aligned basic segment">
                <div class="ui list">
                    {#each provided as p}
                        <div class="item">
                            <!-- {JSON.stringify(p)} -->
                            <i class="copy outline small grey icon" on:click={copyText(p.value)}></i>
                            <div class="content">
                                <div class="header">{p.key}</div>
                                <div class="description">{p.value}</div>
                            </div>
                        </div>                    
                    {/each}
                </div>                

            </div>
            <div class="ui left aligned basic segment">
                <form class="ui form keys">
                    {#each items as it}
                        <div class="field">
                            <label>{it.place.name} / {it.field.name || it.field.definition}</label>
                            <div class:disabled={working} class="ui right icon big fluid input">
                                <input bind:value={ values[it.idx] } />
                                <i class="{ icon(values[it.idx]) } icon"></i>
                            </div>
                        </div>
                    {/each}
                </form>
            </div>
        </div>
        <div class="actions">
            <button class="ui black button" on:click={cancel}>
                Cancelar
            </button>
            <button class="ui green right labeled icon button"
                    class:disabled={loading || working || !ready} 
                    class:loading={working} 
                    on:click={identify}>
                Identificar<i class="check icon"/>
            </button>
        </div>
    </div>
</Modal>
<style>
    .content {
        max-height: 70vh;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .content b {
        overflow-x: hidden;
        text-overflow: ellipsis;
        max-width: 98%;
        display: inline-block;
    }

    .keys .input {
        margin-bottom: 18px;
    }

    .copy {
        cursor: pointer;
    }
</style>
